package com.shadowings.gero.data.lessons.chapter4


import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.DistractorPool
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.lessons.calculateIndirectGenitivePhrases
import com.shadowings.gero.data.lessons.tokenizePhrase
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_esempio_genitivo_indiretto_femminile_plurale
import gero.composeapp.generated.resources.exp_content_esempio_genitivo_indiretto_femminile_singolare
import gero.composeapp.generated.resources.exp_content_esempio_genitivo_indiretto_maschile_plurale
import gero.composeapp.generated.resources.exp_content_esempio_genitivo_indiretto_maschile_singolare
import gero.composeapp.generated.resources.exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non
import gero.composeapp.generated.resources.exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice
import gero.composeapp.generated.resources.exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del
import gero.composeapp.generated.resources.exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al
import gero.composeapp.generated.resources.exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa
import gero.composeapp.generated.resources.exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t
import gero.composeapp.generated.resources.exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w
import gero.composeapp.generated.resources.exp_title_genitivo_indiretto_ii
import gero.composeapp.generated.resources.exp_title_lezione_completata

fun getGenitivoIndiretto2Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_esempio_genitivo_indiretto_maschile_singolare,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D58-M17-V31-G5-N35-M17-X1:I9-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_esempio_genitivo_indiretto_femminile_singolare,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-V28-X1:F1A-N35:X1-A47-G43-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_esempio_genitivo_indiretto_maschile_plurale,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D58-M17-V31-G43-G5-N35:Z7-M17-X1:I9-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_esempio_genitivo_indiretto_femminile_plurale,
            face = Faces.Surprised,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-V28-Z7:X1-F1A-N35:X1-A47-G43-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_indiretto_ii,
            content = Res.string.exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al,
            face = Faces.Surprised
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del,
            face = Faces.Perfect
        )
    )
}

fun getGenitivoIndiretto2QuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    // Each triple: (possessed, connector, possessor)
    // Connectors reflect Genitivo indiretto II forms with common omissions.
    val triples = listOf(
        // Masculine singular -> n(y) ~ n
        Triple("FALCO", ":N35-", "PADRE"),
        Triple("ALBERO", ":N35-", "PASTORE"),
        Triple("VINO", ":N35-", "MADRE"),
        Triple("ACQUA", "-N35-", "PADRE"),

        // Feminine singular -> n(y)t ~ nt
        Triple("PANE", "-N35:X1-", "SACERDOTE"),
        Triple("MUCCA", "-N35:X1-", "PASTORE"),
        Triple("BIRRA", "-N35:X1-", "DONNA"),
        Triple("GATTA", "-N35:X1-", "SCRIBA"),

        // Masculine plural -> n(y)w ~ nw
        Triple("FALCHI", "-N35:Z7-", "PADRE"),
        Triple("ALBERI", "-N35-Z7-", "SACERDOTE"),
        Triple("PASTORI", "-N35:Z7-", "MADRE"),
        Triple("TORI", "-N35:Z7-", "PASTORE"),

        // Feminine plural -> n(yw)t ~ nt (y,w usually omitted)
        Triple("MUCCHE", "-N35:X1-", "PASTORE"),
        Triple("DONNE", "-N35:X1-", "PADRE"),
        Triple("GATTE", "-N35:X1-", "SACERDOTE")
    ).shuffled()

    val firstPart = triples.take(7)
    val secondPart = triples.drop(7)

    return calculateIndirectGenitivePhrases(words, firstPart, languageCode)
        .map { phrase ->
            val possessedWord = phrase.possessedWord
            val possessorWord = phrase.possessorWord
            val correctTokens = phrase.correctTokens

            val otherWords = DistractorPool.words(words).filter {
                it.id != possessedWord.id && it.id != possessorWord.id &&
                        !it.getArticolo(languageCode).isNullOrBlank() &&
                        it.getArticolo(languageCode) != "-" &&
                        !it.getGenitivo(languageCode).isNullOrBlank() &&
                        it.getGenitivo(languageCode) != "-"
            }
            val wrongWords = otherWords.shuffled().take(3)
            // tokenizePhrase splits any multi-word field (a compound vocabulary meaning like
            // "König von Oberägypten", or a multi-word Spanish genitive like "de la") into
            // separate one-word tiles instead of one glued distractor tile.
            val wrongTokens = mutableListOf<String>()
            wrongWords.forEach { ww ->
                ww.getArticolo(languageCode)
                    ?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
                val meaning = ww.inlineMeaning(languageCode, ww.getMeaning(languageCode).split(",")[0].trim())
                wrongTokens.addAll(tokenizePhrase(meaning))
                ww.getGenitivo(languageCode)
                    ?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
            }

            // Never let a distractor collide (case-insensitively) with a token the correct answer
            // actually needs — otherwise a duplicate tile would silently swallow the real one.
            // distinct() only applies to the distractor pool: correctTokens can legitimately repeat
            // a word (e.g. "the wine of the priest" needs "the" twice), and deduping the combined
            // list would collapse that into a single tile, making the phrase unanswerable.
            val allWordsList = (correctTokens + wrongTokens.filter { wt ->
                correctTokens.none { it.trim().lowercase() == wt.trim().lowercase() }
            }.distinct())
                .filter { it.isNotBlank() }
                .shuffled()

            WordSelectionContent(
                hieroglyphs = phrase.hieroglyphs,
                correctPhrase = phrase.correctPhrase,
                words = allWordsList,
                transliteration = "${possessedWord.reading} ${phrase.particleTransliteration} ${possessorWord.reading}"
            )
        } + calculateIndirectGenitivePhrases(words, secondPart, languageCode)
        .map { phrase ->
            TextTranslationContent(
                hieroglyphs = phrase.hieroglyphs,
                correctPhrase = phrase.correctPhrase,
                transliteration = "${phrase.possessedWord.reading} ${phrase.particleTransliteration} ${phrase.possessorWord.reading}"
            )
        }
}

